import { useCognitoAuth } from '@/contexts/cognitoAuthContext'
import { DashboardExperiments } from '@/experiments'
import { useFlag } from '@/hooks/useFlag'
import { useGetAccountInfo } from '@/queries/account/useGetAccountInfo'
import { CoreLevelFeatureNames } from '@/services/types/permissions/permissionFeatures/mockCorePermissionFeature'
import { useCorePermissions } from '@/stores/permissions/permissions'
import { useMemo } from 'react'

export const useShouldShowBillingAndPayments = () => {
  const { accountId } = useCognitoAuth()
  const { data: accountInfo, isLoading: isAccountInfoLoading } = useGetAccountInfo({ accountId })
  const billingAndPaymentsPermission = useCorePermissions(CoreLevelFeatureNames.billingAndPayments)
  const showBillingAndPaymentsPage = useFlag(DashboardExperiments.billingAndPaymentsPage)

  const shouldShow = useMemo(() => {
    const hasPermission = !!billingAndPaymentsPermission?.view
    return (
      showBillingAndPaymentsPage || (hasPermission && accountInfo?.accountType === 'SELF_SERVE')
    )
  }, [billingAndPaymentsPermission, showBillingAndPaymentsPage, accountInfo])

  return { shouldShow, isAccountInfoLoading }
}
